import {createSlice, ActionReducerMapBuilder} from '@reduxjs/toolkit'
import {SliceStatus, RESOURCE_TYPE_SINGULAR} from 'interfaces'
import {
  resetShadowIT,
  setShadowITFilter,
  resetShadowITFilterUpdated,
} from './analyticsShadowITActions'

interface AnalyticsShadowITSliceState {
  shadowIT: ShadowITState
  status: string
  error: string
}

interface ShadowITState {
  searchTerm: string
  searchDisplayValue: string
  searchType: RESOURCE_TYPE_SINGULAR
  filterUpdated?: boolean
}

const initialShadowIT: ShadowITState = {
  searchTerm: '',
  searchDisplayValue: '',
  searchType: '' as RESOURCE_TYPE_SINGULAR,
  filterUpdated: false,
}

const analyticsShadowITSlice = createSlice({
  name: 'analyticsShadowIT',
  initialState: {
    shadowIT: initialShadowIT,
    status: SliceStatus.idle,
    error: '',
  },
  reducers: {},
  extraReducers: (
    builder: ActionReducerMapBuilder<AnalyticsShadowITSliceState>,
  ) =>
    builder
      .addCase(setShadowITFilter, (state, action) => ({
        ...state,
        shadowIT: {
          ...state.shadowIT,
          searchTerm: action?.payload?.searchTerm,
          searchDisplayValue: action?.payload?.searchDisplayValue,
          searchType: action?.payload?.searchType,
          filterUpdated: true,
        },
      }))
      .addCase(resetShadowIT, state => ({
        ...state,
        shadowIT: initialShadowIT,
      }))
      .addCase(resetShadowITFilterUpdated, state => ({
        ...state,
        shadowIT: {
          ...state.shadowIT,
          filterUpdated: false,
        },
      }))
      .addDefaultCase(state => state),
})

export const {
  reducer: analyticsShadowITReducer,
  name: analyticsShadowITReducerName,
} = analyticsShadowITSlice

export type TAnalyticsShadowITActions =
  | ReturnType<typeof setShadowITFilter>
  | ReturnType<typeof resetShadowIT>
  | ReturnType<typeof resetShadowITFilterUpdated>

export const analyticsShadowITActions = {
  setShadowITFilter,
  resetShadowIT,
  resetShadowITFilterUpdated,
}

export type AnalyticsShadowITState = ReturnType<typeof analyticsShadowITReducer>
